export const userViewVrHistoryReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_USER_VIEW_VR_HISTORY_LIST_REQUEST":
      return { ...state, loading: true, userViewVrHistoryList: null };

    case "GET_USER_VIEW_VR_HISTORY_LIST_SUCCESS":
      return { ...state, loading: false, userViewVrHistoryList: action.payload };

    case "GET_USER_VIEW_VR_HISTORY_LIST_FAILED":
      return { ...state, loading: false, userViewVrHistoryList: null, error: action.payload };

    case "GET_USER_VIEW_VR_HISTORY_REQUEST":
      return { ...state, loading: true, userViewVrHistory: null };

    case "GET_USER_VIEW_VR_HISTORY_SUCCESS":
      return { ...state, loading: false, userViewVrHistory: action.payload };

    case "GET_USER_VIEW_VR_HISTORY_FAILED":
      return { ...state, loading: false, userViewVrHistory: null, error: action.payload };

    case "DELETE_USER_VIEW_VR_HISTORY_REQUEST":
      return { ...state, loading: true };

    case "DELETE_USER_VIEW_VR_HISTORY_SUCCESS":
      return { ...state, loading: false };

    case "DELETE_USER_VIEW_VR_HISTORY_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};